import { colorSort } from "@cardheim/utils";
import type React from "react";
import { MagicSymbols } from "../MagicSymbols";
import { CardImageInCommandItem } from "./CardImageInCommandItem";
import type { MagicCommandItemProps } from "./MagicCommandItem";

type Props = Omit<MagicCommandItemProps, "onSelect">;

export const RawCommandItemContent: React.FC<Props> = ({
	image,
	selected,
	title,
	colors,
	description,
	extra,
}) => {
	return (
		<>
			{image && (
				<CardImageInCommandItem
					alt={image.alt}
					src={image.src}
					selected={selected}
				/>
			)}
			<div className="flex flex-wrap w-full">
				<div className="w-full flex gap-2 items-start">
					<p>{title}</p>
					<div className="flex gap-0.5 ml-auto mt-1">
						{colors !== null && (
							<MagicSymbols
								size={12}
								symbols={
									colors
										.sort(colorSort)
										.map((c) => `{${c}}`)
										.join() || "{C}"
								}
							/>
						)}
					</div>
				</div>
				<div className="w-full flex justify-between">
					<p className="text-xs">{description}</p>
					{extra}
				</div>
			</div>
		</>
	);
};
